import { useState } from 'react';
import { TFunction } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { logEvent } from '@amplitude/analytics-browser';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconExpandLess from '@mui/icons-material/ExpandLess';
import IconExpandMore from '@mui/icons-material/ExpandMore';
import Typography from '../Typography';
import Button from '../Button';
import { initiateFinanceRequest } from '../../services/servicing';
import { FINANCE_REQUEST, INVOICE_FINANCING } from '../../constants/auth';
import { COLORS } from '../../themev2';

export default function FinanceInvoices({
  companyId,
  t,
  event: amplitudeEvent,
  tKey = 'servicing',
  onClickFundingRequest,
}: {
  companyId: number;
  t: TFunction;
  event: string;
  tKey?: string;
  onClickFundingRequest?: () => void;
}) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenLanguageMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseLanguageMenu = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button endIcon={anchorEl ? <IconExpandLess /> : <IconExpandMore />} onClick={handleOpenLanguageMenu}>
        {t(`${tKey}:fundingRequestBtn`)}
      </Button>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-language-selector"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleCloseLanguageMenu}
      >
        <MenuItem
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '4px',
            '&:hover': {
              backgroundColor: '#F5F9FF',
            },
          }}
          onClick={async () => {
            logEvent(amplitudeEvent, { type: 'Manual' });
            await initiateFinanceRequest(companyId).then((data) => navigate(`${FINANCE_REQUEST}/${data.id}`));
            setAnchorEl(null);
          }}
        >
          <Typography
            sx={{ lineHeight: '21px', fontWeight: '500', fontSize: '14px', color: COLORS.brand.night }}
          >
            {t('servicing:manualFundingRequest')}
          </Typography>
          <Typography
            sx={{ lineHeight: '18px', fontWeight: '400', fontSize: '12px', color: COLORS.gray[1100] }}
          >
            {t('servicing:manualFundingDescription')}
          </Typography>
        </MenuItem>
        <MenuItem
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '4px',
            '&:hover': {
              backgroundColor: '#F5F9FF',
            },
          }}
          onClick={() => {
            logEvent(amplitudeEvent, { type: 'Bulk' });
            if (onClickFundingRequest) {
              onClickFundingRequest();
            } else {
              navigate(INVOICE_FINANCING, { state: { openFundingRequest: true } });
            }
            setAnchorEl(null);
            // navigate(`${BULK_FINANCE_REQUEST}`);
          }}
        >
          <Typography
            sx={{ lineHeight: '21px', fontWeight: '500', fontSize: '14px', color: COLORS.brand.night }}
          >
            {t('servicing:bulkFundingRequest')}
          </Typography>
          <Typography
            sx={{ lineHeight: '18px', fontWeight: '400', fontSize: '12px', color: COLORS.gray[1100] }}
          >
            {t('servicing:bulkFundingDescription')}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}
